import * as React from 'react';
import classNames from 'classnames';
import { Component } from 'react';
import propz from 'propz';
import debounce from 'debounce-promise';
import './Autocomplete.css';

interface Props {
  onSelect: (item: any) => void;
  searchFunction: (value: string) => any;
  getElementTitle: (item: any) => string;
  defaultItem?: any;
  customClass?: string;
  disabled?: boolean;
  placeholder?: string;
  isItemWithImage?: boolean;
  tabIndex?: number;
}

interface State {
  isLoading: boolean;
  itemList: any[];
  isOpen: boolean;
  currentText: string;
}

// component with onClear function
export class Autocomplete2 extends Component<Props, State> {
  searchFunctionDebounced: any;

  static defaultProps = {
    disabled: false
  };

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      itemList: [],
      isOpen: false,
      currentText: undefined
    };
  }

  componentDidMount() {
    const { searchFunction, defaultItem, getElementTitle } = this.props;
    this.searchFunctionDebounced = debounce(searchFunction, 500);
    if (typeof defaultItem !== 'undefined') {
      this.setState({
        currentText: getElementTitle(defaultItem)
      });
    }
  }

  /** Checks on new props if we need to set default item */
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { defaultItem, getElementTitle } = this.props;
    const { defaultItem: nextDefaultItem } = nextProps;
    // Eliminating infinite looping by checking if really props update take place
    if (nextDefaultItem && JSON.stringify(nextDefaultItem) !== JSON.stringify(defaultItem)) {
      // Change current text (value in input field) on props.defaultItem, if received new props.defaultItem
      this.setState({
        currentText: getElementTitle(nextDefaultItem)
      });
    }
    if (typeof nextDefaultItem === 'undefined') {
      this.setState({
        currentText: undefined
      });
    }
  }

  onClear = () => {
    const { onSelect } = this.props;
    onSelect(undefined);
  };

  onChange = event => {
    event.preventDefault();

    const value = event.target.value;

    if (value === '') {
      this.onClear();
    }

    this.search(value);
  };

  onFocus = () => {
    const { currentText } = this.state;
    this.search(currentText);
  };

  search(value: string) {
    this.setState({
      isLoading: true,
      currentText: value
    });

    this.searchFunctionDebounced(value).then(data => {
      this.setState(
        {
          isLoading: false,
          itemList: data,
          isOpen: true
        },
        () => {
          document.addEventListener('click', this.closeMenu);
        }
      );
    });
  }

  closeMenu = () => {
    this.setState({ isOpen: false }, () => {
      document.removeEventListener('click', this.closeMenu);
    });
  };

  onItemClick = (event, item) => {
    event.preventDefault();
    const currentText = this.props.getElementTitle(item);

    //don't remember remove listener
    document.removeEventListener('click', this.closeMenu);

    this.setState({
      currentText: currentText,
      isOpen: false
    });

    this.props.onSelect(item);
  };

  renderItems() {
    const { itemList } = this.state;
    const { isItemWithImage } = this.props;

    if (itemList.length == 0) {
      return (
        <a href="" className="dropdown-item disabled">
          No results
        </a>
      );
    }

    return itemList.map((item, index) => {
      if (isItemWithImage) {
        const postcode = propz.get(item, ['postcode', 'postcode'], '');
        const address = propz.get(item, ['address'], '');
        const subTitle = `Address: ${postcode}, ${address}`;
        const pic = propz.get(item, ['pic'], '');
        return (
          <a
            href=""
            className="dropdown-item"
            key={`autocomplete_${index}`}
            onClick={event => this.onItemClick(event, item)}
          >
            <div className="bSchoolListItem">
              <div className="eSchoolListItem_wrapper">
                <div className="eSchoolListItem_wrapper_pic">
                  <img className="eSchoolListItem_pic" src={pic} alt={''} />
                </div>
                <div className="eSchoolListItem_name">{this.props.getElementTitle(item)}</div>
              </div>
              <div className="eSchoolListItem_address">{subTitle}</div>
            </div>
          </a>
        );
      } else {
        return (
          <a
            href=""
            className="dropdown-item text-wrap"
            key={`autocomplete_${index}`}
            onClick={event => this.onItemClick(event, item)}
          >
            {this.props.getElementTitle(item)}
          </a>
        );
      }
    });
  }

  getCurrentText(): string {
    const { currentText } = this.state;
    const { defaultItem, getElementTitle } = this.props;

    switch (true) {
      case typeof currentText !== 'undefined':
        return currentText;
      case typeof defaultItem !== 'undefined':
        return getElementTitle(defaultItem);
      default:
        return '';
    }
  }

  onKeyPress = event => {
    if (event.key === 'Tab') {
      this.setState({ isOpen: false });
    }
  };

  render() {
    const { isLoading, isOpen } = this.state;

    const { customClass, disabled, placeholder, tabIndex } = this.props;
    const autocompleteClass = classNames('bAutocomplete', customClass);

    return (
      <div className={autocompleteClass}>
        <input
          className="form-control eAutocompleteInput"
          value={this.getCurrentText()}
          onChange={this.onChange}
          onFocus={this.onFocus}
          onKeyDown={this.onKeyPress}
          disabled={disabled}
          placeholder={placeholder}
          tabIndex={tabIndex}
        />
        {isLoading && <div className={'spinner-border spinner-border-sm eAutocompleteSpinner'} />}

        {isOpen && <div className="dropdown-menu w-100 show eShowDropdownMenu">{this.renderItems()}</div>}
      </div>
    );
  }
}



